import React, { useEffect, useState } from 'react';

import StdDialog from 'components/Dialogs/StdDialog';
import DrawerDialogFrame from 'components/Drawers/DrawerDialogFrame';

type TransactionEditSurfaceProps = {
  children: React.ReactNode;
  isDrawer: boolean;
  onBack: () => void;
  onClose: () => void;
  open: boolean;
  showBackButton: boolean;
  title: string;
};

type TransactionEditDrawerSurfaceProps = Omit<TransactionEditSurfaceProps, 'isDrawer'>;

function TransactionEditDrawerSurface({
  children,
  onBack,
  onClose,
  open,
  showBackButton,
  title,
}: TransactionEditDrawerSurfaceProps): React.JSX.Element | null {
  const [hasRenderedContent, setHasRenderedContent] = useState(open);

  useEffect(() => {
    if (open) {
      setHasRenderedContent(true);
    }
  }, [open]);

  // StandardDrawer owns the transition. Retaining its children prevents the
  // drawer edge and content from disappearing before the exit animation ends.
  if (!hasRenderedContent) {
    return null;
  }

  return (
    <DrawerDialogFrame title={title} onBack={onBack} onClose={onClose} showBackButton={showBackButton}>
      {children}
    </DrawerDialogFrame>
  );
}

export default function TransactionEditSurface({
  children,
  isDrawer,
  onBack,
  onClose,
  open,
  showBackButton,
  title,
}: TransactionEditSurfaceProps): React.JSX.Element | null {
  if (isDrawer) {
    return (
      <TransactionEditDrawerSurface
        onBack={onBack}
        onClose={onClose}
        open={open}
        showBackButton={showBackButton}
        title={title}
      >
        {children}
      </TransactionEditDrawerSurface>
    );
  }

  if (!open) {
    return null;
  }

  return (
    <StdDialog
      disableRestoreFocus
      onBack={onBack}
      onClose={onClose}
      open={open}
      sharedcomponentid='TRANSACTION_DETAILS_DIALOG'
      showBackButton={showBackButton}
      size='md'
      title={title}
    >
      {children}
    </StdDialog>
  );
}
